package org.chiangmeng.qfast

import androidx.compose.ui.ExperimentalComposeUiApi
import androidx.compose.ui.window.ComposeViewport
import kotlinx.browser.document
import org.jetbrains.skiko.wasm.onWasmReady

@OptIn(ExperimentalComposeUiApi::class)
fun main() {
    initKoin()
    onWasmReady {
        val root = document.getElementById("ComposeTarget") ?: document.body!!
        ComposeViewport(root) {
            App()
        }
    }
}